// The Legal IQ Assessment — 9 self-diagnostic questions about THE USER'S brand.
// No right/wrong answers. The Claude-generated result reads their answers as a
// snapshot of their business and returns a personalized Brand Protection Priority Map.

export const ASSESSMENT_QUESTIONS = [
  {
    id: "stage",
    question: "Where are you at with this business right now?",
    helper: "Be honest — there's no wrong answer.",
    options: [
      { id: "idea", label: "Still an idea — I haven't launched yet" },
      { id: "early", label: "Launched in the last 12 months" },
      { id: "growing", label: "1 to 3 years in and growing" },
      { id: "established", label: "3+ years in and established" },
      { id: "multi", label: "I'm juggling more than one business" },
    ],
  },
  {
    id: "valuable_asset",
    question: "Of these, what feels like the most valuable thing your business has built so far?",
    helper: "Pick the one that would hurt the most to lose.",
    options: [
      { id: "name", label: "My business name" },
      { id: "offer", label: "The name of my course, program, or podcast" },
      { id: "framework", label: "A signature phrase, framework, or method I'm known for" },
      { id: "logo", label: "My logo or visual identity" },
      { id: "personal", label: "My personal brand or audience" },
      { id: "unsure", label: "Honestly not sure — that's part of why I'm here" },
    ],
  },
  {
    id: "operating_reach",
    question: "Where do customers come to you from?",
    options: [
      { id: "local", label: "Mostly local — one city or region" },
      { id: "state", label: "Across my state" },
      { id: "national", label: "Nationwide" },
      { id: "global", label: "Globally / international" },
      { id: "starting", label: "Just getting started — too early to say" },
    ],
  },
  {
    id: "google_check",
    question: "When you Google your business name, what comes up?",
    helper: "If you've never checked, that's a valid answer.",
    options: [
      { id: "clean", label: "Just me — clear and clean results" },
      { id: "mostly_me", label: "Mostly me, with a few unrelated mentions" },
      { id: "similar", label: "A few businesses with names like mine" },
      { id: "dominated", label: "Someone else dominates the results" },
      { id: "stale", label: "Haven't checked in a long time" },
      { id: "never", label: "Never actually checked" },
    ],
  },
  {
    id: "protection_status",
    question: "What's your trademark situation right now?",
    options: [
      { id: "registered", label: "I have a federal trademark registered (®)" },
      { id: "filed", label: "I've filed an application — it's in process" },
      { id: "considered", label: "I've thought about it but haven't filed" },
      { id: "llc_only", label: "I assumed my LLC handles it" },
      { id: "unknown", label: "Trademark… what's that actually do for me?" },
    ],
  },
  {
    id: "gut_twist",
    question: "Have you ever felt that gut twist seeing someone else using something close to your brand?",
    helper: "Could be a name, a tagline, a course title, a logo — anything that hit too close.",
    options: [
      { id: "multiple", label: "Yes, more than once" },
      { id: "once", label: "Yes, once" },
      { id: "no_unchecked", label: "No — but I haven't really looked" },
      { id: "no_flattered", label: "No — and honestly, I'd be flattered" },
      { id: "active", label: "I've had a direct dispute already (cease-and-desist, takedown, etc.)" },
    ],
  },
  {
    id: "walk_away",
    question: "If you had to walk away from one of these tomorrow, which would hurt the most?",
    options: [
      { id: "name", label: "My business name" },
      { id: "offer", label: "My signature offer, program, or podcast name" },
      { id: "audience", label: "My audience or following" },
      { id: "domain", label: "My website domain" },
      { id: "personal", label: "My personal name — it IS my brand" },
    ],
  },
  {
    id: "naming_process",
    question: "How did you land on your current brand name?",
    options: [
      { id: "gut", label: "I felt strongly about it and didn't really vet it" },
      { id: "domain", label: "I checked the .com was available" },
      { id: "self_search", label: "I did a Google + USPTO search myself" },
      { id: "pro", label: "I worked with a pro (lawyer or branding strategist)" },
      { id: "unsure", label: "I'm still not 100% sold on it" },
    ],
  },
  {
    id: "biggest_fear",
    question: "When you think about your brand long-term, what worries you most?",
    options: [
      { id: "copycats", label: "Someone copying me or my work" },
      { id: "cease_desist", label: "Getting hit with a cease-and-desist" },
      { id: "forced_rebrand", label: "Being forced to rebrand after I've built momentum" },
      { id: "cost", label: "Paying a lawyer thousands when I don't know if I need to" },
      { id: "unknown_unknowns", label: "Not knowing what I don't know" },
      { id: "nothing", label: "Honestly nothing — I just want to know what to do next" },
    ],
  },
];

// Human-readable lookup so backend / display layers can show the label, not the id.
export const labelFor = (questionId, optionId) => {
  const q = ASSESSMENT_QUESTIONS.find((x) => x.id === questionId);
  if (!q) return optionId;
  const opt = q.options.find((o) => o.id === optionId);
  return opt?.label || optionId;
};
